export const LOADING_MESSAGE = 'Loading your Page...';
